import { NotFound } from '@/components/pages/Errors/NotFound'
import { Page } from '@/core/architecture'

import { OwnedItemDetailTemplate } from './template'
import { useViewModel } from './viewModel'

export const OwnedItemDetail: Page = () => {
  const { state, actions } = useViewModel()

  if (!state.loading && !state.portfolio) {
    return <NotFound useNextRouter={false} />
  }

  /**
   * NFT 停止に向けて、NFTアイテムの詳細ページを表示しない
   * NFT 機能停止後には削除して問題ない
   */
  if (state.portfolio?.item?.nft?.chains) {
    return <NotFound useNextRouter={false} />
  }

  return <OwnedItemDetailTemplate state={state} {...actions} />
}
